import Vue from 'vue'
import store from '@/store'
import VueRouter from 'vue-router'
import Login from '@/views/login/index.vue'
import Account from '@/views/login/account.vue'
import Phone from '@/views/login/phone.vue'
import Forget from '@/views/login/forget.vue'
import EmailRegister from '@/views/register/emailRegister.vue'
import PhoneRegister from '@/views/register/phoneRegister.vue'
import Intermediate from '@/views/login/intermediate.vue'
import NotFound from '@/views/notFound/index.vue'
import utils from '@/utils/index'
import short from '@/views/short/index.vue'
import { LoginSSOAPI } from '@/axios/login'
import { redirectUrl } from '@/axios/home'
Vue.use(VueRouter)

const routes = [
  {
    path: '/:lang(en-US|zh-HK)?/d/:id',
    name: 'short',
    component: short,
    meta: {
      title: 'Feemoo',
      icon: '/favicon.ico',
    },
  },
  {
    path: '/:lang(en-US|zh-HK)?/intermediate',
    name: 'intermediate',
    component: Intermediate,
    meta: {
      title: 'Feemoo',
      icon: '/favicon.ico',
    },
  },
  {
    path: '/:lang(en-US|zh-HK)?/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Feemoo',
      icon: '/favicon2.ico',
    },
  },
  {
    path: '/:lang(en-US|zh-HK)?/account',
    name: 'account',
    component: Account,
    meta: {
      title: 'Feemoo',
      icon: '/favicon2.ico',
    },
  },
  {
    path: '/:lang(en-US|zh-HK)?/phone',
    name: 'phone',
    component: Phone,
    meta: {
      title: 'Feemoo',
      icon: '/favicon2.ico',
    },
  },
  {
    path: '/:lang(en-US|zh-HK)?/forget',
    name: 'forget',
    component: Forget,
    meta: {
      title: 'Feemoo',
      icon: '/favicon2.ico',
    },
  },
  {
    path: '/:lang(en-US|zh-HK)?/phoneRegister',
    name: 'phoneRegister',
    component: PhoneRegister,
    meta: {
      title: 'Feemoo',
      icon: '/favicon2.ico',
    },
  },
  {
    path: '/:lang(en-US|zh-HK)?/emailRegister',
    name: 'emailRegister',
    component: EmailRegister,
    meta: {
      title: 'Feemoo',
      icon: '/favicon2.ico',
    },
  },
  {
    path: '/:lang(en-US|zh-HK)?/',
    name: 'notFound',
    component: NotFound,
    meta: {
      title: 'Feemoo',
      icon: '/favicon.ico',
    },
  },
  {
    path: '*',
    redirect: '/',
    meta: {
      title: 'Feemoo',
      icon: '/favicon.ico',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
// 在全局导航守卫中检查元字段-全局前置守卫
router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  //将作为中间页跳转原始地址 逻辑弃用
  // if (to.query.content) {
  //   try {
  //     let res = await redirectUrl({
  //       content: to.query.content,
  //     })
  //     if (res.status == 1) {
  //       window.location.href = res.data.jump_url
  //     } else {
  //       next(to.path)
  //     }
  //   } catch (error) {
  //     next(to.path)
  //   }
  //   return
  // }
  // 处理 platfro 参数逻辑
  if (to.query.platfro) {
    localStorage.setItem('platfro', to.query.platfro)
    try {
      const res = await LoginSSOAPI({
        token: to.query.platfro,
      })
      if (res.status == 1) {
        // const userCookie = utils.getCookie(Vue.prototype.$glb.fmCookieName)
        // if (userCookie) {
        //   next(to.path)
        // } else {
        //   setTimeout(() => {
        //     next(to.path)
        //   }, 600)
        // }
        store.commit('setAttr', {
          name: 'isLogin',
          val: 1,
        })
        localStorage.setItem('shortLogin', 1)
        localStorage.setItem('shortToken', res.data.authtoken)
        next(to.path)
      }
    } catch (error) {}
    return
  }
  if (to.name != 'register') {
    if (store.state.language == 'en' && !to.fullPath.includes('/en-US')) {
      next({ path: '/en-US' + to.fullPath })
    } else if (
      store.state.language == 'hk' &&
      !to.fullPath.includes('/zh-HK')
    ) {
      next({ path: '/zh-HK' + to.fullPath })
    } else if (store.state.language == 'cn') {
      if (!to.fullPath.includes('/en-US') && !to.fullPath.includes('/zh-HK')) {
        next()
      } else {
        const newPath = to.fullPath.replace('/en-US', '').replace('/zh-HK', '')
        next({ path: newPath })
      }
    } else {
      next()
    }
  } else {
    if (!to.fullPath.includes('/en-US') && !to.fullPath.includes('/zh-HK')) {
      next()
    } else {
      const newPath = to.fullPath.replace('/en-US', '').replace('/zh-HK', '')
      next({ path: newPath })
    }
  }
  //路由跳转时关闭快捷登录弹窗
  store.commit('setShowLoginShort', '')
  store.commit('setShowLogin', false)
})
router.afterEach((to) => {
  // 获取页面的icon配置
  const icon = to.meta.icon || '/favicon.ico'
  
  // 确保DOM已加载
  const favicon = document.getElementById('dynamicFavicon')
  if (favicon) {
    // 解决浏览器缓存问题，添加随机参数
    favicon.href = icon + '?v=' + Date.now()
  } else {
    // 如果不存在则创建一个link标签
    const link = document.createElement('link')
    link.id = 'dynamicFavicon'
    link.rel = 'icon'
    link.href = icon + '?v=' + Date.now()
    document.head.appendChild(link)
  }
})
// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}
export default router
